<template>
  <div>
    <div class="slide mb-5">
      <div class="bg-img">
        <div class="slide-content">
          <div>
            <h2 class="slide-header">{{$t('message.locations')}}</h2>
          </div>
          <div>
            <h5 class="slide-h5">{{$t('message.home')}}</h5>
            <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider"></b-icon>
            <h5 class="slide-h5">{{$t('message.locations')}}</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-container-location mt-5">
      <div class="tools-card mb-4">
    <div class="row align-items-center gx-2">

        <div class="col-md-4 mb-2 mb-md-0">
            <label class="tools-label">Technical Person</label>
            
            <VSelect
                :options="technicalsList"
                label="name"
                placeholder="Select Technical"
                @input="handleTechnicalChange"
            />
        </div>

        <div class="col-md-2 mb-2 mb-md-0">
            <label class="tools-label">Window:</label>
            <select v-model="timeWindow" class="form-select form-select-sm">
                <option value="all">All</option>
                <option value="15">Last 15 min</option>
                <option value="30">Last 30 min</option>
                <option value="60">Last 60 min</option>
            </select>
        </div>

        <div class="col-md-2 mb-2 mb-md-0">
            <label class="tools-label">Replay speed:</label>
            <select v-model="replaySpeed" class="form-select form-select-sm">
                <option value="1">x1</option>
                <option value="2">x2</option>
                <option value="5">x5</option>
            </select>
        </div>

        <div class="col-md-2 mb-2 mb-md-0 d-flex gap-2">
            <button  @click="replayTrail" class="btn btn-primary btn-sm w-100 mt-4">Replay</button>
        </div>

        <div class="col-md-2 d-flex">
            <button @click="clearTrail" class="btn btn-danger btn-sm w-100 mt-4">Clear</button>
        </div>

    </div>
</div>


      <div id="map" style="height: 500px; width: 100%;"></div>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import firebase from "firebase/compat/app";
import "firebase/compat/database";
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: { VSelect: vSelect },

  data() {
    return {
      map: null,
      marker: null,
      // نقاط التتبع: [{latLng: L.LatLng, t: number}]
      points: [],
      // كل جزء Polyline منفصل لثبات أكتر
      segmentLayers: [],
      breadcrumbDots: [],
      trailGroup: null,

      selectedTechnical: null,
      technicalsList: [],

      replayTimer: null,
      replaySpeed: 1, // x1, x2, x5
      windowMinutes: 0, // 0 = All
    };
  },

  mounted() {
    this.initializeMap();
    this.getTechnicalList();
    this.listenForEmployeeChanges();
  },

  computed: {
    ...mapGetters(["getUser"]),
    company_id() {
      return this.getUser;
    },
    isRTL() {
      return this.$i18n.locale === "ar";
    },
  },

  methods: {
    initializeMap() {
      this.map = L.map("map").setView([30.0444, 31.2357], 10);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
      }).addTo(this.map);

      // LayerGroup نمسح ونضيف فيه كل الطبقات المتعلقة بالمسار
      this.trailGroup = L.layerGroup().addTo(this.map);
    },

    getTechnicalList() {
      firebase
        .database()
        .ref("technicals/" + this.company_id.company_id)
        .on("value", (snap) => {
          const data = snap.val();
          if (!data) return;

          this.technicalsList = Object.keys(data)
            .filter((k) => data[k].technicalCompanyId == this.company_id.company_id)
            .map((k) => ({
              id: k,
              name: data[k].technicalName,
              lat: data[k].technicalLatitude,
              lng: data[k].technicalLongitude,
            }));
        });
    },

    handleTechnicalChange(tech) {
      // امسح كل حاجة قديمة
      this.clearTrail(true); // keepSelected=false handled inside

      if (!tech) {
        this.selectedTechnical = null;
        return;
      }

      this.selectedTechnical = tech.id;

      // لو عنده لوكيشن ابتدائي
      if (tech.lat && tech.lng) {
        const p = L.latLng(Number(tech.lat), Number(tech.lng));
        const t = Date.now(); // مفيش timestamp؟ نعمله محليًا
        this.points = [{ latLng: p, t }];

        // Marker
        this.marker = L.marker(p).addTo(this.map);
        this.map.setView(p, 15);

        // Breadcrumb أول نقطة
        const dot = L.circleMarker(p, { radius: 4, opacity: 0.8 }).addTo(this.trailGroup);
        this.breadcrumbDots.push(dot);
      }
    },

    listenForEmployeeChanges() {
      const ref = firebase.database().ref("technicals/" + this.company_id.company_id);
      ref.on("child_changed", (s) => this.updateMarker(s.key, s.val()));
      ref.on("child_added", (s) => this.updateMarker(s.key, s.val()));
    },

    updateMarker(key, emp) {
      // قبل أي حاجة: لازم يكون فيه مختار
      if (!this.selectedTechnical) return;
      if (String(key) !== String(this.selectedTechnical)) return;

      const lat = Number(emp.technicalLatitude);
      const lng = Number(emp.technicalLongitude);
      if (!lat || !lng || isNaN(lat) || isNaN(lng)) return;

      const now = Date.now();
      const newLL = L.latLng(lat, lng);
      const newPoint = { latLng: newLL, t: now };

      // أول نقطة
      if (!Array.isArray(this.points)) this.points = [];
      if (this.points.length === 0) {
        this.points.push(newPoint);
        // Marker
        if (!this.marker) this.marker = L.marker(newLL).addTo(this.map);
        else this.marker.setLatLng(newLL);

        // Breadcrumb
        const dot = L.circleMarker(newLL, { radius: 4, opacity: 0.8 }).addTo(this.trailGroup);
        this.breadcrumbDots.push(dot);

        this.map.setView(newLL, 15);
        return;
      }

      // نقطة سابقة
      const prev = this.points[this.points.length - 1];
      // تجاهل لو نفس النقطة
      if (prev && prev.latLng && prev.latLng.equals(newLL)) {
        return;
      }

      // Smooth move للماركر
      if (!this.marker) this.marker = L.marker(newLL).addTo(this.map);
      this.smoothMove(this.marker, prev.latLng, newLL);

      // خزّن النقطة
      this.points.push(newPoint);

      // Breadcrumb للنقطة السابقة (دبوس صغير)
      const dot = L.circleMarker(prev.latLng, { radius: 3, opacity: 0.6 }).addTo(this.trailGroup);
      this.breadcrumbDots.push(dot);

      // حساب السرعة للون المسار
      const dtSec = Math.max(0.001, (newPoint.t - prev.t) / 1000);
      const distMeters = this.map.distance(prev.latLng, newLL);
      const speedKmh = (distMeters / dtSec) * 3.6;
      const color = this.speedColor(speedKmh);

      // Segment آمن من نقطتين valid فقط
      const seg = L.polyline([prev.latLng, newLL], {
        color,
        weight: 4,
        opacity: 0.9,
      }).addTo(this.trailGroup);
      this.segmentLayers.push({ layer: seg, t: newPoint.t });

      // تطبيق فلتر آخر X دقيقة
      this.applyWindowFilter();
    },

    clearTrail(keepSelected = true) {
      // امسح الماركر
      if (this.marker) {
        this.map.removeLayer(this.marker);
        this.marker = null;
      }

      // امسح كل الطبقات في الجروب
      if (this.trailGroup) {
        this.trailGroup.clearLayers();
      }

      // Reset arrays
      this.points = [];
      this.segmentLayers = [];
      this.breadcrumbDots = [];

      if (!keepSelected) {
        this.selectedTechnical = null;
      }

      // أوقف أي Replay
      if (this.replayTimer) {
        clearInterval(this.replayTimer);
        this.replayTimer = null;
      }
    },

    applyWindowFilter() {
      if (!this.windowMinutes || this.windowMinutes <= 0) {
        // All — لا تمسح حاجة
        return;
      }
      const cutoff = Date.now() - this.windowMinutes * 60 * 1000;

      // فلترة النقاط
      const newPoints = [];
      for (let i = 0; i < this.points.length; i++) {
        const p = this.points[i];
        if (p && p.t >= cutoff) newPoints.push(p);
      }
      this.points = newPoints;

      // امسح كل الطبقات وأعد الرسم من points بعد الفلترة
      this.trailGroup.clearLayers();
      this.segmentLayers = [];
      this.breadcrumbDots = [];

      // أعد وضع breadcrumbs والـsegments
      for (let i = 0; i < this.points.length; i++) {
        const p = this.points[i];
        // رسم breadcrumb
        const dot = L.circleMarker(p.latLng, { radius: 3, opacity: 0.6 }).addTo(this.trailGroup);
        this.breadcrumbDots.push(dot);

        if (i === 0) {
          // أول نقطة: حط الماركر عليها
          if (!this.marker) this.marker = L.marker(p.latLng).addTo(this.map);
          this.marker.setLatLng(p.latLng);
          continue;
        }
        const prev = this.points[i - 1];
        // لون حسب السرعة
        const dtSec = Math.max(0.001, (p.t - prev.t) / 1000);
        const dist = this.map.distance(prev.latLng, p.latLng);
        const v = (dist / dtSec) * 3.6;
        const color = this.speedColor(v);

        const seg = L.polyline([prev.latLng, p.latLng], {
          color,
          weight: 4,
          opacity: 0.9,
        }).addTo(this.trailGroup);
        this.segmentLayers.push({ layer: seg, t: p.t });
      }
    },

    speedColor(kmh) {
      // ألوان بسيطة: <10 أخضر – <30 أصفر – غير كده أحمر
      if (kmh < 10) return "#2ecc71"; // slow - green
      if (kmh < 30) return "#f1c40f"; // medium - yellow
      return "#e74c3c"; // fast - red
    },

    smoothMove(marker, fromLL, toLL) {
      // حركة بسيطة آمنة بدون Polyline
      const duration = 600; // ms
      const frames = 30;
      let f = 0;
      const latDiff = toLL.lat - fromLL.lat;
      const lngDiff = toLL.lng - fromLL.lng;

      const timer = setInterval(() => {
        f++;
        const lat = fromLL.lat + (latDiff * f) / frames;
        const lng = fromLL.lng + (lngDiff * f) / frames;
        marker.setLatLng([lat, lng]);
        if (f >= frames) clearInterval(timer);
      }, duration / frames);
    },

    replayTrail() {
      if (this.replayTimer) {
        clearInterval(this.replayTimer);
        this.replayTimer = null;
      }

      // نقاط نظيفة
      const clean = this.points.filter(
        (p) => p && p.latLng instanceof L.LatLng && !isNaN(p.latLng.lat) && !isNaN(p.latLng.lng)
      );
      if (clean.length < 2) return;

      // شبح ماركر
      const ghost = L.marker(clean[0].latLng).addTo(this.map);
      let i = 0;

      const baseInterval = 300; // ms
      const interval = Math.max(30, baseInterval / this.replaySpeed);

      this.replayTimer = setInterval(() => {
        ghost.setLatLng(clean[i].latLng);
        i++;
        if (i >= clean.length) {
          clearInterval(this.replayTimer);
          this.replayTimer = null;
          this.map.removeLayer(ghost);
        }
      }, interval);
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 500px;
  border-radius: 20px;
}
.custom-container-location {
  padding-left: 200px;
  padding-right: 200px;
}
.controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 14px;
  flex-wrap: wrap;
}
.controls select, .controls button, .controls label {
  font-size: 14px;
}
@media (max-width: 576px) {
  .custom-container-location {
    padding-left: 15px;
    padding-right: 15px;
  }
}
.tools-card {
  background: #fff;
  padding: 12px 15px;
  padding-bottom: 25px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.07);
  margin-bottom: 15px;
  border: 1px solid #eee;
}

.tools-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 3px;
  display: block;
}

.v-select {
  font-size: 14px;
}

</style>
